import { render, staticRenderFns } from "./AnnouncementBoxContent.vue?vue&type=template&id=4ea4cc6f&"
import script from "./AnnouncementBoxContent.vue?vue&type=script&lang=js&"
export * from "./AnnouncementBoxContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports